// extracted by mini-css-extract-plugin
export default {"title":"homepage-headline_title__xPl-n","titleAccent":"homepage-headline_titleAccent__FL5Sf","dot":"homepage-headline_dot__8kZex","jump":"homepage-headline_jump__mOZZi"};